import { Box } from "@twilio-paste/core/box";
import { Heading } from "@twilio-paste/core/heading";
import { Paragraph } from "@twilio-paste/core/paragraph";
import React from "react";
import HomeGetStartedInclusive from "../../../assets/icons/get-started-inclusive.svg";
import { GetStartedCard, GetStartedCardIllustration, GetStartedCardLink } from "../GetStartedCard";

interface GetStartedInclusiveProps {
    animationDelay: number;
}

export const GetStartedInclusive: React.FC<GetStartedInclusiveProps> = ({ animationDelay }) => (
    <GetStartedCard animationDelay={animationDelay}>
        <Box display="flex" height="100%" flexDirection="column" justifyContent="space-between">
            <div>
                <GetStartedCardIllustration>
                    <HomeGetStartedInclusive aria-hidden="true" />
                </GetStartedCardIllustration>
                <Heading as="h2" variant="heading30">
                    Actions
                </Heading>
                <Paragraph>
                    Take advantage of UI actions by listening, intercepting and manipulating UI events
                </Paragraph>
            </div>
            <GetStartedCardLink to="/ui-actions/ActionsManager">Go to Actions</GetStartedCardLink>
        </Box>
    </GetStartedCard>
);
